import * as React from 'react';

import type { DiscoveryCollection } from 'bundles/browse/components/types/DiscoveryCollections';
import ListGoogleSchemaWithIds from 'bundles/seo/components/ListGoogleSchemaWithIds';

type Props = {
  discoveryCollections: Array<DiscoveryCollection | null>;
};

const ListGoogleSchemaWithCatalogResults = ({ discoveryCollections }: Props) => {
  const courseIds: Array<string> = [];
  const specializationIds: Array<string> = [];

  discoveryCollections.forEach((collection) => {
    if (collection && collection.entities) {
      collection.entities.forEach((entity) => {
        if (entity && entity.__typename === 'DiscoveryCollections_course') {
          courseIds.push(entity.id);
        } else if (entity && entity.__typename === 'DiscoveryCollections_specialization') {
          specializationIds.push(entity.id);
        }
      });
    }
  });

  return <ListGoogleSchemaWithIds courseIds={courseIds} specializationIds={specializationIds} />;
};

export default ListGoogleSchemaWithCatalogResults;
